<script lang="ts">
  import { emissions, surveyStatus, currentQuestion } from '../../stores'

  $surveyStatus.currentUserAnswer = [$currentQuestion.answers[0]]
</script>

<div class="viz-content">
  <span>{$emissions.toFixed(2)}</span><br />
  <h3>kgCO<sub>2</sub>e</h3>
</div>

<style>
  .viz-content span {
    font-weight: 600;
    font-size: 80px;
  }
  h3 {
    margin: 0;
    font-weight: 600;
  }

  @media (min-width: 400px) {
    .viz-content span {
      font-size: 130px;
    }
  }
</style>
